
import { Skeleton } from 'antd';

const CardMapSearch = (props) => {
  const {
    event = {}
  } = props;
  const {detail = {}} = event;
  const { title = '', results = [] } = detail;

  // console.log('CardMapSearch结果', results);

  return (
    <div className="px-24px pr-16px mr-4px mb-16px flex-grow overflow-x-hidden overflow-y-auto scrollbar">
      {results?.length === 0 ? (
        <Skeleton active />
      ) : (
        <div className="flex flex-wrap gap-16px w-full text-14px text-black">
          {title && <div className="font-medium">{title}</div>}
          <div className="flex flex-wrap gap-16px w-full">
            {results?.map((item, index) => {
              return (
                <div
                  key={`map-search-${index}`}
                  className="flex items-center gap-8px w-full overflow-hidden"
                >
                  <img
                    src="https://s1.ssl.qhres2.com/static/3d51da463e5a8fd4.svg"
                    alt=""
                    width="16"
                    height="16"
                  />
                  <div className="text-ellipsis whitespace-nowrap overflow-hidden">
                    {item}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default CardMapSearch;
